import CheckPoints from './CheckPoints';

export default CheckPoints;
